import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import { isMobile } from "react-device-detect";
import Tooltip from "@mui/material/Tooltip";
export default function ShowAllStores(props) {
  const [checked, setChecked] = React.useState(false);
  React.useEffect(() => {
    setChecked(props.showAllStoresCheck);
  }, [props.showAllStoresCheck, props.checkNearStore]);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    props.getAllStores(event.target.checked);
  };

  return (
    <>
      <Tooltip title="Show all stores">
        <Checkbox
          checked={checked}
          onChange={handleChange}
          color="default"
          style={{
            padding: isMobile ? "4px" : "4px",
            flexDirection: "column",
            fontSize: "12px",
            fontFamily: "Roboto",
          }}
        />
      </Tooltip>
    </>
  );
}
